// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld-base';
import './usageMonitorStatsDialog';

myw.UsageMonitorPlugin = myw.Plugin.extend({
    /**
     * @class A debug tool to monitor statistics gathered by the Usage Monitor
     */
    initialize(owner, options) {
        myw.Plugin.prototype.initialize.call(this, owner, options);
        const usageMonitor = this.app.system.usageMonitor;
        const active = usageMonitor.config && usageMonitor.config.active;
        if (!active) return;

        this.app.ready.then(() => {
            this.app.notifyUser({
                plugin: this,
                icon: $('<span/>', { html: 'U', class: 'usage-monitor-launcher' }),
                onClick: this.handleDialogDisplay.bind(this)
            });
        });

        usageMonitor.on('usageMonitor-persist', () => {
            this.app.notifyUser({
                plugin: this,
                icon: $('<span/>', { html: 'U', class: 'usage-monitor-launcher active' }),
                onClick: this.handleDialogDisplay.bind(this)
            });

            setTimeout(() => {
                this.app.notifyUser({
                    plugin: this,
                    icon: $('<span/>', { html: 'U', class: 'usage-monitor-launcher' }),
                    onClick: this.handleDialogDisplay.bind(this)
                });
            }, 1000);
        });

        this.dialog = new myw.UsageMonitorStatsDialog({ owner });
    },

    handleDialogDisplay() {
        this.dialog.show();
    }
});

export default myw.UsageMonitorPlugin;
